import { FunctionComponent } from "react";

import { PresetButtonType } from "@bps/fluent-ui";
import { FilterBar } from "@components/filter-bar/FilterBar";
import { Item } from "@components/filter-bar/FilterBar.types";
import {
  useLicenceTypes,
  useSourceTypes
} from "@libs/api/gateways/plt/plt-gateway.hooks";

import {
  LicencesFilterProps,
  LicencesFilterValues
} from "./LicencesFilter.types";

export const LicencesFilter: FunctionComponent<LicencesFilterProps> = ({
  tenantId,
  ...filterProps
}) => {
  const { data: licencesTypes = [] } = useLicenceTypes();
  const { data: sourceTypes = [] } = useSourceTypes();

  const items: Item<LicencesFilterValues>[] = [
    {
      type: "usersSelect",
      name: "userIds",
      stickItem: true,
      props: {
        placeholder: "Select users",
        multiSelect: true,
        tenantId,
        styles: { root: { minWidth: 250 } }
      }
    },
    {
      type: "optionsSelect",
      name: "licenceType",
      stickItem: true,
      props: {
        options: licencesTypes.map(type => ({
          key: type.code,
          text: type.text
        })),
        placeholder: "Licence type code",
        styles: { root: { paddingLeft: 8, minWidth: 150 } }
      }
    },
    {
      type: "optionsSelect",
      name: "doNotRenew",
      stickItem: true,
      props: {
        options: [
          {
            key: "False",
            text: "Auto-renew"
          },
          {
            key: "True",
            text: "Do not renew"
          }
        ],
        placeholder: "Auto-renew",
        styles: { root: { paddingLeft: 8, minWidth: 105 } }
      }
    },
    {
      type: "optionsSelect",
      name: "source",
      stickItem: true,
      props: {
        options: sourceTypes.map(type => ({
          key: type.code,
          text: type.text
        })),
        placeholder: "Source",
        styles: { root: { paddingLeft: 8, minWidth: 70 } }
      }
    }
  ];

  const presets: PresetButtonType<LicencesFilterValues>[] = [
    {
      name: "isInactive",
      text: "Show inactive",
      iconName: "GlobalNavButtonActive"
    },
    { name: "isExpired", text: "Show expired", iconName: "DateTime" }
  ];

  return (
    <FilterBar<LicencesFilterValues>
      {...filterProps}
      items={items}
      presets={presets}
      initialValues={{
        isExpired: false,
        isInactive: false
      }}
    />
  );
};
